<template>
    <app-layout>
        <template #header>
            <FarmTitle :farm="farm">
                Pferdeeinzug
            </FarmTitle>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <div class="p-8">
                        <div>
                            <h3 class="text-lg leading-6 font-medium text-gray-900">
                                Pferd hinzufügen
                            </h3>
                        </div>
                        <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                            <div class="col-span-6">
                                <label for="horse_name" class="block text-sm font-medium text-gray-700">
                                    Name
                                </label>
                                <div class="mt-1">
                                    <input type="text" name="first_name" id="horse_name" v-model="form.name" autocomplete="given-name" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                    <jet-input-error :message="form.errors.name" />
                                </div>
                            </div>
                            <div class="col-span-6 md:col-span-3">
                                <label for="stables" class="block text-sm font-medium text-gray-700">
                                    Stall
                                </label>
                                <div class="mt-1">
                                    <VueNextSelect
                                        :options="stables"
                                        v-model="form.stable_id"
                                        :label-by="(x) => {
                                                            return `${x.name} (${x.current_price.pivot.value})`
                                                        }"
                                        value-by="id"
                                        searchable
                                        clear-on-close
                                        close-on-select
                                        search-placeholder="Besitzer auswählen"
                                    />
                                    <jet-input-error :message="form.errors.stable_id" />
                                </div>
                            </div>
                            <div class="col-span-6 md:col-span-3">
                                <div class="relative flex items-start">
                                    <div class="flex items-center h-5">
                                        <input id="comments" v-model="form.empty" aria-describedby="comments-description" name="comments" type="checkbox" class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded">
                                    </div>
                                    <div class="ml-3 text-sm">
                                        <label for="comments" class="font-medium text-gray-700">Leerbox</label>
                                        <p id="comments-description" class="text-gray-500">Den Stall als Leerbox buchen</p>
                                    </div>
                                    <jet-input-error :message="form.errors.empty" />
                                </div>
                            </div>
                            <div class="col-span-6">
                                <label class="block text-sm font-medium text-gray-700">
                                    Besitzer
                                </label>
                                <div class="mt-1 flex">
                                    <VueNextSelect
                                        :options="customers"
                                        v-model="form.customer_id"
                                        :label-by="(x) => x.name+' ('+x.kdnr+')'"
                                        value-by="id"
                                        searchable
                                        clear-on-close
                                        close-on-select
                                        search-placeholder="Besitzer auswählen"
                                    />
                                    <button @click="add_customer = true" type="button" class="ml-4 inline-flex items-center p-1.5 border border-transparent rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                        <PlusIcon class="h-5 w-5" aria-hidden="true" />
                                    </button>
                                </div>
                                <jet-input-error :message="form.errors.customer_id" />
                            </div>
                            <div class="col-span-6">
                                <label for="date" class="block text-sm font-medium text-gray-700">
                                    Datum
                                </label>
                                <div class="mt-1">
                                    <input type="date" name="first_name" id="date" v-model="form.date" autocomplete="given-name" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                    <jet-input-error :message="form.errors.date" />
                                </div>
                                <p class="text-gray-700" v-if="form.date <= farm.last_export">
                                    Der Differenzbetrag zur letzten Abrechnung (also vom {{ new Intl.DateTimeFormat('de-DE').format(new Date(form.date)) }} bis zum {{ new Intl.DateTimeFormat('de-DE').format(new Date(farm.last_export)) }}) wird zum {{ new Intl.DateTimeFormat('de-DE').format(new Date(farm.last_export)) }} in Rechnung gestellt und beim nächsten Export mit abgebucht.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="pt-5 pr-8 pb-8">
                        <div class="flex justify-end">
                            <inertia-link :href="route('farm.horses', {farm: farm})" type="button" class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                Abbrechen
                            </inertia-link>
                            <button @click="form.post(route('horse.onboard.post', {farm: farm}))" class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                Pferd hinzufügen
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <jet-dialog-modal :show="add_customer">
            <template #title>
                Kunden hinzufügen
            </template>

            <template #content>
                <div class="mt-6 md:grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                    <div class="col-span-6">
                        <label for="name" class="block text-sm font-medium text-gray-700" >
                            Name
                        </label>
                        <div class="mt-1">
                            <input type="text" name="first_name" id="name" v-model="add_customer_form.name" autocomplete="name" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                            <jet-input-error :message="add_customer_form.errors.name" />
                        </div>
                    </div>
                    <div class="col-span-6">
                        <label for="email" class="block text-sm font-medium text-gray-700" >
                            E-Mail
                        </label>
                        <div class="mt-1">
                            <input type="text" name="first_name" id="email" v-model="add_customer_form.email" autocomplete="email" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                            <jet-input-error :message="add_customer_form.errors.email" />
                        </div>
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="flex justify-end">
                    <button @click="add_customer = false" type="button" class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        Abbrechen
                    </button>
                    <button @click="add_customer_form.post(route('farm.customers.store', {farm: farm}), {
                        onSuccess: () => {
                            add_customer = false;
                        }
                    })" class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        Kunde erstellen
                    </button>
                </div>
            </template>
        </jet-dialog-modal>
    </app-layout>
</template>

<script>
    import AppLayout from "@/Layouts/AppLayout";
    import JetInputError from "@/Jetstream/InputError";
    import FarmTitle from "@/Layouts/FarmTitle";
    import VueNextSelect from 'vue-next-select';
    import JetDialogModal from "@/Jetstream/DialogModal";
    import { PlusIcon } from "@heroicons/vue/solid";

    export default {
        name: "OnBoarding",
        components: { AppLayout, JetInputError, FarmTitle, VueNextSelect, JetDialogModal, PlusIcon },
        props: ['farm', 'horse', 'enter_date', 'customers', 'stables'],
        data() {
            return {
                form: this.$inertia.form({
                    name: null,
                    customer_id: null,
                    stable_id: null,
                    date: this.enter_date,
                    empty: false,
                }),
                add_customer: false,
                add_customer_form: this.$inertia.form({
                    name: '',
                    email: '',
                }),
            }
        }
    }
</script>

<style>
    @keyframes loading{0%{transform:rotate(0deg)}to{transform:rotate(360deg)}}.icon.delete{display:flex;justify-content:center;align-items:center;padding:0;margin:0;border:0;background:0 0;height:8px;width:8px;min-height:8px;min-width:8px;max-height:8px;max-width:8px;cursor:pointer}.icon.arrow-downward{color:#999;border-style:solid;border-width:4px 4px 0;border-color:#999 transparent transparent;content:'';transition:transform .2s linear;cursor:pointer}.icon.arrow-downward.active{transform:rotate(180deg)}.vue-select{position:relative;display:flex;align-items:flex-start;justify-content:flex-start;flex-direction:column;width:150px;border-radius:4px;border:1px solid #999;box-sizing:border-box;outline:0}.vue-select[data-is-focusing=true]:not([data-visible-length='0']){border-bottom-left-radius:0;border-bottom-right-radius:0}.vue-select.disabled{background-color:rgba(239,239,239)}.vue-dropdown[data-removable=false] .vue-dropdown-item.selected:hover,.vue-select.disabled *,.vue-select.disabled input,.vue-tags[data-removable=false] .vue-tag.selected img:hover{cursor:not-allowed}.vue-select-header{display:flex;width:100%;align-items:center;justify-content:space-between}.vue-select-header .icon.arrow-downward,.vue-select-header .icon.loading,.vue-tag span{margin-right:4px}.vue-tags{display:flex;flex-wrap:wrap;margin:0;padding:2px;min-height:calc(1rem + 4px);user-select:none}.vue-tags.collapsed{flex-wrap:nowrap;overflow:auto}.vue-tag{display:none;align-items:center;list-style-type:none;border-radius:4px;margin:2px;min-height:1rem}.vue-tag,.vue-tag.selected{justify-content:center;background-color:#999;padding:0 4px;font-size:.8rem}.vue-dropdown,.vue-input{min-width:0;box-sizing:border-box}.vue-input,.vue-tag.selected{display:flex;align-items:center;border-radius:4px}.vue-input{max-width:100%;padding:4px}.vue-select[data-is-focusing=false] .vue-input input,input[readonly]{cursor:default}.vue-input,.vue-input input{border:0;outline:0;width:100%}.vue-input input{min-width:0;font-size:.8rem;padding:0}.vue-input input[disabled]{background-color:rgba(239,239,239)}.vue-input input[readonly],.vue-select-header .vue-input input[disabled]{background-color:unset}.vue-dropdown{position:absolute;background-color:#fff;z-index:1;max-height:300px;overflow-y:auto;width:inherit;left:-1px;margin:0;padding:0;border-bottom-left-radius:4px;border-bottom-right-radius:4px;border:1px solid #999;list-style-type:none}.vue-dropdown[data-visible-length='0']{border:0}.vue-dropdown-item{list-style-type:none;padding:4px;cursor:pointer;min-height:1rem}.vue-dropdown-item.highlighted{background-color:#41b883}.vue-dropdown-item.disabled{background-color:rgba(239,239,239);cursor:not-allowed}.vue-dropdown-item.selected{background-color:#f3f3f3}.vue-dropdown-item.selected.highlighted{background-color:#ff6a6a}.vue-dropdown[data-addable=false][data-multiple=true] .vue-dropdown-item:not(.selected):hover{cursor:not-allowed}.icon.loading{display:inline-block;position:relative;width:8px;min-width:8px;height:8px;min-height:8px}.icon.loading div{box-sizing:border-box;display:block;position:absolute;border:1px solid #999;width:8px;height:8px;border-radius:50%;animation:loading 1s cubic-bezier(.5,0,.5,1) infinite;border-color:#999 transparent transparent}.icon.loading div:nth-child(1){animation-delay:-.08s}.icon.loading div:nth-child(2){animation-delay:-.16s}.inline-flex{display:inline-flex}
</style>
